/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { useRef } from 'react';
import { useIntl } from 'react-intl';
import Link from 'next-translate-routes/link';

import Slider, { Settings } from 'react-slick';

import { PostsTile } from '@components/molecules/PostsTile';

import { linkResolver } from '@prismic/prismic-config';
import { Tag } from '@prismic/gqlTypes/prismicTypes';

import { mediumScreen, smallScreen } from '@styles/constants';

import { commonMessages } from '../../../../intl';

import { PageLink, IProps } from './types';
import * as S from './styles';

export const PostsSlider: React.FC<IProps> = ({ path, posts }) => {
  const sliderSettings: Settings = {
    arrows: true,
    autoplay: false,
    dots: false,
    infinite: false,
    responsive: [
      {
        breakpoint: mediumScreen,
        settings: {
          slidesToShow: 2,
          swipeToSlide: true,
        },
      },
      {
        breakpoint: smallScreen,
        settings: {
          slidesToShow: 1,
          swipeToSlide: true,
        },
      },
    ],
    slidesToScroll: 1,
    slidesToShow: 3,
  };

  const slider = useRef(null);
  const intl = useIntl();

  return (
    <S.Wrapper className="posts-slider">
      <S.Header className="posts-slider__header">
        <S.Title className="posts-slider__header__title">
          {intl.formatMessage(commonMessages.youMayAlsoLike)}
        </S.Title>
        <Link href={path} passHref>
          <S.Link className="posts-slider__header__link">
            {intl.formatMessage(commonMessages.showMore)}
          </S.Link>
        </Link>
      </S.Header>
      <Slider {...sliderSettings} ref={slider}>
        {posts &&
          posts.map((pagelink, i) => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const item = pagelink as PageLink;
            if (!item) {
              return null;
            }

            const tags = item?.tags?.map(({ tag }) => {
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              const _tag = tag as Partial<Tag>;
              return _tag.name;
            });

            return (
              <S.Slide>
                <PostsTile
                  key={item?._meta?.id}
                  link={linkResolver(item)}
                  image={item?.image}
                  title={item?.title}
                  tags={item?.category ? [item?.category] : tags}
                />
              </S.Slide>
            );
          })}
      </Slider>
    </S.Wrapper>
  );
};
